// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.repo-stats {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: rgb(106, 115, 125);
}

.repo-left-stat {
  flex-grow: 1;
  display: flex;
}

.language-color {
  width: 10px;
  height: 10px;
  background-color: blue;
  margin-right: 0.25rem;
  border-radius: 100%;
}

.repo-left-stat span {
  display: flex;
  align-items: center;
  margin-right: 0.75rem;
}

.repo-name-div {
  display: flex;
  align-items: center;
}

.repo-svg {
  margin-right: 0.5rem;
  min-width: 16px;
}

.repo-name {
  white-space: nowrap;
  line-height: 1.1;
  text-overflow: ellipsis;
  color: rgb(36, 41, 46);
  font-family: "Google Sans Regular";
  margin-bottom: 0.75rem;
  font-size: 25px;
  font-weight: 700;
  letter-spacing: -0.5px;
  overflow: hidden;
  margin: 0px;
}

.repo-star-svg {
  margin-right: 0.3rem;
}

.repo-description {
  word-wrap: break-word;
  text-align: justify;
  display: -webkit-box;
  display: block;
  font-family: "Google Sans Regular";
  /* -webkit-line-clamp: 4;
  -webkit-box-orient: vertical; */
}

.repo-details {
  display: flex;
  flex-direction: row;
}

.flexDiv {
  display: flex;
  margin: 0;
  flex-direction: row;
  justify-content: space-between;
}
.Leftitem {
  align-content: flex-start;
}
.Rightitem {
  align-items: flex-end;
}

.repo-creation-date {
  margin: 0;
  font-family: "Google Sans Regular";
  font-weight: 400;
  margin-left: 0px;
  margin-right: auto;
}

@media (max-width: 768px) {
  .repo-name {
    font-size: 16px;
  }

  .repo-description {
    font-size: 14px;
  }

  .repo-details {
    flex-direction: column;
  }

  .repo-creation-date {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ProjectCard/ProjectCard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EAEb,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EAEE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EAEb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,kCAAkC;EAClC,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,kCAAkC;EAClC;iCAC+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".repo-stats {\n  display: flex;\n  -webkit-box-pack: justify;\n  justify-content: space-between;\n  font-size: 13px;\n  color: rgb(106, 115, 125);\n}\n\n.repo-left-stat {\n  -webkit-box-flex: 1;\n  flex-grow: 1;\n  display: flex;\n}\n\n.language-color {\n  width: 10px;\n  height: 10px;\n  background-color: blue;\n  margin-right: 0.25rem;\n  border-radius: 100%;\n}\n\n.repo-left-stat span {\n  display: flex;\n  -webkit-box-align: center;\n  align-items: center;\n  margin-right: 0.75rem;\n}\n\n.repo-name-div {\n  display: flex;\n  align-items: center;\n}\n\n.repo-svg {\n  margin-right: 0.5rem;\n  min-width: 16px;\n}\n\n.repo-name {\n  white-space: nowrap;\n  line-height: 1.1;\n  text-overflow: ellipsis;\n  color: rgb(36, 41, 46);\n  font-family: \"Google Sans Regular\";\n  margin-bottom: 0.75rem;\n  font-size: 25px;\n  font-weight: 700;\n  letter-spacing: -0.5px;\n  overflow: hidden;\n  margin: 0px;\n}\n\n.repo-star-svg {\n  margin-right: 0.3rem;\n}\n\n.repo-description {\n  word-wrap: break-word;\n  text-align: justify;\n  display: -webkit-box;\n  display: block;\n  font-family: \"Google Sans Regular\";\n  /* -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical; */\n}\n\n.repo-details {\n  display: flex;\n  flex-direction: row;\n}\n\n.flexDiv {\n  display: flex;\n  margin: 0;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.Leftitem {\n  align-content: flex-start;\n}\n.Rightitem {\n  align-items: flex-end;\n}\n\n.repo-creation-date {\n  margin: 0;\n  font-family: \"Google Sans Regular\";\n  font-weight: 400;\n  margin-left: 0px;\n  margin-right: auto;\n}\n\n@media (max-width: 768px) {\n  .repo-name {\n    font-size: 16px;\n  }\n\n  .repo-description {\n    font-size: 14px;\n  }\n\n  .repo-details {\n    flex-direction: column;\n  }\n\n  .repo-creation-date {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
